import { ref } from 'vue';
import axios from 'axios';
import { API_BASE_URL } from '@/config/api';
import store from '@/state/store';

// Kundenliste aus der Rechnungsdatenbank (readonly, ADMIN-only).
// GET /admin/customers → { customers: [{num, type, company, firstname, lastname, zip, city, invoicingDisabled}] }

export const adminCustomers = ref([]);
export const adminCustomersLoading = ref(false);
export const adminCustomersError = ref('');
let customersPromise = null;
let customersInFlight = false;

// force: gecachte Liste verwerfen (z.B. Seiten, die Flags wie invoicingDisabled/akontoRequired anzeigen)
export const loadAdminCustomers = ({ force = false } = {}) => {
  if (!store.getters['auth/canAccessAdmin']) return Promise.resolve([]);
  if (force && !customersInFlight) customersPromise = null;
  if (!customersPromise) {
    customersInFlight = true;
    adminCustomersLoading.value = true;
    adminCustomersError.value = '';
    // Ohne Timeout bliebe ein hängender Request ewig «in Arbeit» und alle Aufrufer warteten mit
    customersPromise = axios.get(`${API_BASE_URL}/admin/customers`, { withCredentials: true, timeout: 20000 })
      .then((res) => {
        adminCustomers.value = Array.isArray(res.data?.customers) ? res.data.customers : [];
        return adminCustomers.value;
      })
      .catch((error) => {
        customersPromise = null; // nächster Aufruf versucht es erneut
        adminCustomersError.value = error?.code === 'ECONNABORTED'
          ? 'Zeitüberschreitung beim Laden der Kunden.'
          : (error?.response?.data?.error || error?.response?.data?.message || error?.message || 'Kunden konnten nicht geladen werden.');
        return adminCustomers.value;
      })
      .finally(() => {
        customersInFlight = false;
        adminCustomersLoading.value = false;
      });
  }
  return customersPromise;
};

// Bezeichnung: Firma bei Firmenkunden, sonst Vorname Nachname.
export const customerDisplayName = (customer) => {
  if (!customer) return '';
  const company = String(customer.company || '').trim();
  if (customer.type === 'business' && company) return company;
  const person = [customer.firstname, customer.lastname].map((v) => String(v || '').trim()).filter(Boolean).join(' ');
  return company || person;
};

export const customerFullLabel = (customer) => {
  const name = customerDisplayName(customer);
  return name ? `${customer.num} — ${name}` : String(customer?.num ?? '');
};

export const customerByNum = (num) => {
  const wanted = Number(num);
  if (!Number.isFinite(wanted)) return null;
  return adminCustomers.value.find((c) => Number(c.num) === wanted) || null;
};

// „100562 — Muster AG“; unbekannte/fremde Nummern (oder Nicht-Admin) → nur Nummer.
export const customerLabelByNum = (num) => {
  const customer = customerByNum(num);
  return customer ? customerFullLabel(customer) : String(num ?? '');
};
